import { Select, MenuItem } from '@mui/material'
import { DropDownProps, MenuItem as MenuItemType } from './DropDown.types'

export const DropDown = ({
  value,
  menuItems,
  label,
  className,
  IconComponent,
  onChange,
  name,
  defaultLabel,
  ...otherProps
}: DropDownProps) => {
  const listItems =
    menuItems.length > 0
      ? menuItems.map((item: MenuItemType) => (
          <MenuItem key={item.value} value={item.value}>
            {item.key}
          </MenuItem>
        ))
      : []

  return (
    <Select
      value={value || ''}
      onChange={onChange}
      variant="outlined"
      displayEmpty
      className={className}
      sx={{
        borderRadius: '3px',
        '& .MuiSelect-select': {
          paddingTop: '15px',
          paddingBottom: '14px',
        },
      }}
      inputProps={{ 'aria-label': label, name }}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        PaperProps: {
          style: {
            maxHeight: 300,
            overflowY: 'auto',
          },
        },
      }}
      {...otherProps}
    >
      {defaultLabel && (
        <MenuItem value="" disabled={true}>
          <em>{defaultLabel}</em>
        </MenuItem>
      )}
      {listItems}
    </Select>
  )
}
